module.exports = __webpack_public_path__ + "static/media/icon-check.0f14de03.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-check.svg
// module id = 1729
// module chunks = 0